import fetchJson, { type FetchJsonResponse } from "./fetchJson";
export default fetchJson;
export { FetchJsonResponse };
